/** ----------------------------------------
     Utility
 ---------------------------------------- */

import unique from '@util/unique';

/** ----------------------------------------
     Module Interface
 ---------------------------------------- */

import module from './interface';

/** ----------------------------------------
    State
 ---------------------------------------- */

const getters = {

    /** ----------------------------------------
         All News
     ---------------------------------------- */

    getNews: state => {
        return state.data;
    },

    /** ----------------------------------------
        Amount of News
     ---------------------------------------- */

    getAmountOfNewsItems: state => amount => {
        return state.data.slice(0, amount);
    },

    /** ----------------------------------------
         News by ID
     ---------------------------------------- */

    getNewsById: state => param => {
        const id = parseFloat(param);
        const findId = obj => obj.id === id;
        return state.data.find(findId);
    },

    /** ----------------------------------------
        News by Format
     ---------------------------------------- */

    getNewsByFormat: state => format => {
        if(format === 'all') return state.data;
        return state.data.filter(project => project.formats.includes(format));
    }

};

/** ----------------------------------------
    Export State
 ---------------------------------------- */

export default getters